import React from "react";
import {FeedbackType, ValidationFeedback} from "../types/General";
import Icon from "@mdi/react";
import {mdiAlertOutline, mdiCloseCircleOutline} from "@mdi/js";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({feedback}: { feedback: ValidationFeedback | null }) => {

    if (!feedback || !feedback.text) {
        return <></>;
    }

    return (
        <p className={"mt-1 d-flex align-items-center " + (feedback.type === FeedbackType.Error ? 'text-danger' : 'text-warning')}>
            <small>
                <Icon path={feedback.type === FeedbackType.Error ? mdiCloseCircleOutline : mdiAlertOutline} size={.8}/>
                <span className="ms-1">{feedback.text}</span>
            </small>
        </p>
    );
}